import React, { useState } from 'react';
import {
	ToggleButton, Buzz, Counter,
} from '@aleph/shared-components';
import RedditNotificationsOverlay from 'wb-reddit/app/routes/superGrid/actionRow/notifications/overlay';
import useNotificationsPolling
	from 'wb-reddit/app/routes/superGrid/actionRow/notifications/hooks/useNotificationsPolling';

const RedditNotifications = () => {
	const [notificationsOpen, setNotificationsOpen] = useState(false);
	const { notifications } = useNotificationsPolling();

	return (
		<>
			<ToggleButton
				data-testid="notifications-button"
				onClick={() => setNotificationsOpen(true)}
				leadingIcon={
					<>
						<Buzz
							className="text-gray-950"
						/>
						<Counter
							count={notifications?.length}
							className='top-0 right-0'
							variant="square-accent"
						/>
					</>
				}
			/>

			<RedditNotificationsOverlay
				open={notificationsOpen}
				onClose={() => setNotificationsOpen(false)}
			/>
		</>
	);
};

export default RedditNotifications;
